// add content/page module imports here
import {OverzichtModule} from './overzicht/overzicht.module';
import {mdwBewerkenModule} from './bewerken/mdwbewerken.module';
import {MultiSelectModule} from 'primeng/multiselect';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [
    MultiSelectModule,
  ],

  exports: [
    OverzichtModule,
    mdwBewerkenModule,
  ]
})

export class MedewerkersModule {  };

